import { useEffect } from 'react';

export default function  FubOauthCallback() {

  useEffect(() => {
    if (!window.location.host.includes('127.0.0.1')) {
      window.location.replace('http://127.0.0.1:3000/settings/integrations/fub/code' + window.location.search);
    }
  }, []);

  return null;
}
